import React from 'react'
import {Link} from  'react-router-dom'
import abimg from '../../images/about.jpg'
import shape from '../../images/mainpage/about.jpg'


const About = (props) => {

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }


    return(
        <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-wrap">
                            <div className="wpo-about-img">
                                <img src={shape} alt=""/>
                                <div className="wpo-ab-shape-1">
                                    <div className="s-s1"></div>
                                    <div className="s-s2"></div>
                                </div>
                                {/* <div className="wpo-ab-shape-2"><img src={shape} alt=""/></div> */}
                                {/* <div className="wpo-total-raised">
                                    <div className="wpo-total-raised-wrap">
                                        <div className="wpo-total-raised-icon">
                                            <i className="fi flaticon-wallet-filled-money-tool"></i>
                                        </div>
                                        <div className="wpo-total-raised-text">
                                            <ul>
                                                <li>Total Raised<span>$25000</span></li>
                                            </ul>
                                            <div className="progress-section">
                                                <div className="process">
                                                    <div className="progress">
                                                        <div className="progress-bar">
                                                            <div className="progress-value"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-text">
                            <span>About Us</span>
                            <h2>Empowering Futures with Integrity at Hill Academy</h2>
                            <p>Hill Academy is committed to developing students who excel not only in academics but also in character. We provide Academic Counseling, Mentor Training, and Home Schooling support to foster individuals with strong career paths, respect for human values, and a commitment to ethical principles </p>
                            <ul>
                                <li>Committed to excellence in academics and character development.</li>
<li>Programs include Academic Counseling, Mentor Training, and Home Schooling.</li>
<li>Fostering career success and respect for human values.</li>
<li>Empowering students to reach their fullest potential.</li>
<li>Nurturing individuals ready to lead and contribute to society.</li>


                            </ul>
                            <Link onClick={ClickHandler} className="theme-btn-s2" to="/testimonial">More About</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;